const CSR_ROLES = {
    csr: 'csr',
    superUser: 'superuser',
    sales: 'sales',
};

export default CSR_ROLES;
